import { AlertCircle } from 'lucide-react';
import { useCallback, useState } from 'react';
import { OverviewView } from '../02-OVERVIEW/OverviewView';

const PlanUpskilling = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [loading] = useState(false);
    const [error, setError] = useState(null);

    // Mock des données pour éviter les erreurs du hook useUpskillingData
    const toggleSkillCompletion = useCallback((skillId) => {
        // Ici vous pourrez ajouter la vraie logique plus tard
    }, []);

    // Mock minimal des données pour que votre vue OverviewView fonctionne
    const mockUpskillingData = {
        categories: [], // ✅ Tableau vide - plus de domaine codé en dur
        userAssessment: {},
        completedSkills: [],
        getSkillsToImprove: () => [],
        calculatePathRelevance: () => 50,
        learningPaths: [],
        manager: {
            // Mock minimal du manager
            getCategories: () => [],
            getAllSkills: () => []
        },
        toggleSkillCompletion,
        allSkills: [],
        recommendedSkills: []
    };

    // Gestion des états de chargement et d'erreur
    if (loading) {
        return (
            <div className="max-w-4xl mx-auto flex items-center justify-center py-12">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-[#18574F] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Chargement du plan d'upskilling...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="max-w-4xl mx-auto bg-red-50 border border-red-200 rounded-xl p-6">
                <div className="flex items-center space-x-3">
                    <AlertCircle className="w-6 h-6 text-red-600" />
                    <div>
                        <h3 className="text-lg font-bold text-red-900">Erreur de chargement</h3>
                        <p className="text-red-700">{error}</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                        >
                            Réessayer
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="mt-0">
            <OverviewView
                data={mockUpskillingData}
                toggleSkillCompletion={mockUpskillingData.toggleSkillCompletion}
            />
        </div>
    );
};

export default PlanUpskilling;